var _defs, _rect, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCtaPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 800 400",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "fade",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "white",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "url(#fade)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#0A1F3F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "rgba(0, 132, 255, 0.15)",
    strokeWidth: 1,
    mask: "url(#mask)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 0,
    x2: 100,
    y2: 400
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 0,
    x2: 200,
    y2: 400
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 0,
    x2: 300,
    y2: 400
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 0,
    x2: 400,
    y2: 400
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 0,
    x2: 500,
    y2: 400
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 0,
    x2: 600,
    y2: 400
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 0,
    x2: 700,
    y2: 400
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "rgba(0, 132, 255, 0.15)",
    strokeWidth: 1,
    mask: "url(#mask)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 100,
    x2: 800,
    y2: 100
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 200,
    x2: 800,
    y2: 200
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 300,
    x2: 800,
    y2: 300
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    stroke: "#0084FF",
    strokeWidth: 2,
    filter: "url(#glow)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 200 Q 400 100 800 300",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 300 Q 400 200 800 100",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtaPattern);
export default __webpack_public_path__ + "static/media/cta-pattern.5cbfced603d1ceea705e1686436c9155.svg";
export { ForwardRef as ReactComponent };